import { roundNumberByParams } from '@teinor/erp/prices'
import { displayFormatedNumber } from '../../../utils/globals/numbers'
import useTwinTranslation from '../../../utils/hooks/useTwinTranslation'
import { getCurrencySymbol } from '../../../utils/globals/price'
import { CalculateParamsTy, DisplayPriceTy } from './types'
import { getPreparePricesConfigParam } from '../../../utils/reducers/getters'
import { SpecificPriceRulesPayload } from '../../../utils/reducers/products/specificPriceRules'
import useCalculateParamsWithSpecificPrice from '../../../utils/hooks/product/useCalculateParamsWithSpecificPrice'
import { Modify } from '@teinor/erp'

export type DisplayPriceGettingParamsProps = Modify<DisplayPriceProps, {
    calculateParams?: never
}>

export const DisplayPriceGettingParams: React.FC<DisplayPriceGettingParamsProps> = ({ ...params }) => {
    const calculateParams = getPreparePricesConfigParam() as CalculateParamsTy
    return (
        <DisplayPrice {...params} calculateParams={calculateParams} />
    )
}

export type DisplayPriceGettingSpecificPriceParamsProps = Modify<DisplayPriceProps, {
    calculateParams?: never
    specificPriceRules: SpecificPriceRulesPayload
    SpecificPriceRuleId: number
}>

export const DisplayPriceGettingSpecificPriceParams: React.FC<DisplayPriceGettingSpecificPriceParamsProps> = ({ specificPriceRules, SpecificPriceRuleId, ...params }) => {
    const { decimals, rounding, roundingPriceType } = useCalculateParamsWithSpecificPrice({SpecificPriceRuleId, specificPriceRules})
    return (
        <DisplayPrice {...params} calculateParams={{
                decimals,
                rounding,
                roundingPriceType
        }} />
    )
}

interface DisplayPriceProps extends DisplayPriceLogicProps {
    className?: string
}

const DisplayPrice: React.FC<DisplayPriceProps> = ({ className, ...params }) => {
    const { priceParsed, CurrencySymbol, vatIncluded } = useDisplayPriceLogic(params)
    return (
        <div className={className}>{priceParsed} {CurrencySymbol} {vatIncluded}</div>
    )
}

interface DisplayPriceNotRoundedProps extends DisplayPriceNotRoundedLogicProps {
    className?: string
}

export const DisplayPriceNotRounded: React.FC<DisplayPriceNotRoundedProps> = ({ className, ...params }) => {
    const { priceParsed, CurrencySymbol, vatIncluded } = useDisplayPriceNotRoundedLogic(params)
    return (
        <div className={className}>{priceParsed} {CurrencySymbol} {vatIncluded}</div>
    )
}

interface DisplayPriceNotRoundedLogicProps {
    value: number
    CurrencyId: string
    with_vat: boolean
}

const useDisplayPriceNotRoundedLogic = ({ CurrencyId, value, with_vat }: DisplayPriceNotRoundedLogicProps) => {
    const { t } = useTwinTranslation()
    const valueParsed = isNaN(value) ? 0 : value
    const priceParsed = displayFormatedNumber(valueParsed)
    const CurrencySymbol = getCurrencySymbol(CurrencyId)
    const vatIncluded = with_vat ? t('withVatShort', 'Con imp.') : ''
    return { priceParsed, CurrencySymbol, vatIncluded }
}

interface DisplayPriceLogicProps extends DisplayPriceTy {
}

const useDisplayPriceLogic = ({ CurrencyId, value, with_vat, calculateParams }: DisplayPriceLogicProps) => {
    const { t } = useTwinTranslation()
    let myValue = roundNumberByParams(value, calculateParams.rounding, { roundingPriceType: calculateParams.roundingPriceType })
    const valueParsed = isNaN(myValue) ? 0 : myValue
    const finalValue = valueParsed.toFixed(calculateParams.decimals)
    const priceParsed = displayFormatedNumber(finalValue)
    const CurrencySymbol = getCurrencySymbol(CurrencyId)
    const vatIncluded = with_vat ? t('withVatShort', 'Con imp.') : ''
    return { priceParsed, CurrencySymbol, vatIncluded }
}

export default DisplayPrice